import { ColumnState } from 'ag-grid-community';

export const mapBEGridSettings = (items: ColumnState[]) =>
  items?.map(({ colId, hide, pinned, width }) => ({
    colId,
    hide,
    pinned,
    width,
  }));
